/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./pages/__root";
import { Route as UsersRouteRouteImport } from "./pages/users/route";
import { Route as StringsRouteRouteImport } from "./pages/strings/route";
import { Route as SettingsRouteRouteImport } from "./pages/settings/route";
import { Route as ProfileRouteRouteImport } from "./pages/profile/route";
import { Route as PermissionGroupsRouteRouteImport } from "./pages/permission-groups/route";
import { Route as ApiKeysRouteRouteImport } from "./pages/api-keys/route";
import { Route as IndexRouteImport } from "./pages/index";
import { Route as UsersIndexRouteImport } from "./pages/users/index";
import { Route as StringsIndexRouteImport } from "./pages/strings/index";
import { Route as SettingsIndexRouteImport } from "./pages/settings/index";
import { Route as ProfileIndexRouteImport } from "./pages/profile/index";
import { Route as PermissionGroupsIndexRouteImport } from "./pages/permission-groups/index";
import { Route as ApiKeysIndexRouteImport } from "./pages/api-keys/index";
import { Route as SettingsIntegrationsSlackRedirectRouteImport } from "./pages/settings/integrations/slack-redirect";

const UsersRouteRoute = UsersRouteRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => rootRouteImport,
} as any);
const StringsRouteRoute = StringsRouteRouteImport.update({
  id: "/strings",
  path: "/strings",
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any);
const ProfileRouteRoute = ProfileRouteRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => rootRouteImport,
} as any);
const PermissionGroupsRouteRoute = PermissionGroupsRouteRouteImport.update({
  id: "/permission-groups",
  path: "/permission-groups",
  getParentRoute: () => rootRouteImport,
} as any);
const ApiKeysRouteRoute = ApiKeysRouteRouteImport.update({
  id: "/api-keys",
  path: "/api-keys",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => UsersRouteRoute,
} as any);
const StringsIndexRoute = StringsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => StringsRouteRoute,
} as any);
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SettingsRouteRoute,
} as any);
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ProfileRouteRoute,
} as any);
const PermissionGroupsIndexRoute = PermissionGroupsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PermissionGroupsRouteRoute,
} as any);
const ApiKeysIndexRoute = ApiKeysIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ApiKeysRouteRoute,
} as any);
const SettingsIntegrationsSlackRedirectRoute =
  SettingsIntegrationsSlackRedirectRouteImport.update({
    id: "/integrations/slack-redirect",
    path: "/integrations/slack-redirect",
    getParentRoute: () => SettingsRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/api-keys": typeof ApiKeysRouteRouteWithChildren;
  "/permission-groups": typeof PermissionGroupsRouteRouteWithChildren;
  "/profile": typeof ProfileRouteRouteWithChildren;
  "/settings": typeof SettingsRouteRouteWithChildren;
  "/strings": typeof StringsRouteRouteWithChildren;
  "/users": typeof UsersRouteRouteWithChildren;
  "/api-keys/": typeof ApiKeysIndexRoute;
  "/permission-groups/": typeof PermissionGroupsIndexRoute;
  "/profile/": typeof ProfileIndexRoute;
  "/settings/": typeof SettingsIndexRoute;
  "/strings/": typeof StringsIndexRoute;
  "/users/": typeof UsersIndexRoute;
  "/settings/integrations/slack-redirect": typeof SettingsIntegrationsSlackRedirectRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/api-keys": typeof ApiKeysIndexRoute;
  "/permission-groups": typeof PermissionGroupsIndexRoute;
  "/profile": typeof ProfileIndexRoute;
  "/settings": typeof SettingsIndexRoute;
  "/strings": typeof StringsIndexRoute;
  "/users": typeof UsersIndexRoute;
  "/settings/integrations/slack-redirect": typeof SettingsIntegrationsSlackRedirectRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/api-keys": typeof ApiKeysRouteRouteWithChildren;
  "/permission-groups": typeof PermissionGroupsRouteRouteWithChildren;
  "/profile": typeof ProfileRouteRouteWithChildren;
  "/settings": typeof SettingsRouteRouteWithChildren;
  "/strings": typeof StringsRouteRouteWithChildren;
  "/users": typeof UsersRouteRouteWithChildren;
  "/api-keys/": typeof ApiKeysIndexRoute;
  "/permission-groups/": typeof PermissionGroupsIndexRoute;
  "/profile/": typeof ProfileIndexRoute;
  "/settings/": typeof SettingsIndexRoute;
  "/strings/": typeof StringsIndexRoute;
  "/users/": typeof UsersIndexRoute;
  "/settings/integrations/slack-redirect": typeof SettingsIntegrationsSlackRedirectRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/api-keys"
    | "/permission-groups"
    | "/profile"
    | "/settings"
    | "/strings"
    | "/users"
    | "/api-keys/"
    | "/permission-groups/"
    | "/profile/"
    | "/settings/"
    | "/strings/"
    | "/users/"
    | "/settings/integrations/slack-redirect";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/api-keys"
    | "/permission-groups"
    | "/profile"
    | "/settings"
    | "/strings"
    | "/users"
    | "/settings/integrations/slack-redirect";
  id:
    | "__root__"
    | "/"
    | "/api-keys"
    | "/permission-groups"
    | "/profile"
    | "/settings"
    | "/strings"
    | "/users"
    | "/api-keys/"
    | "/permission-groups/"
    | "/profile/"
    | "/settings/"
    | "/strings/"
    | "/users/"
    | "/settings/integrations/slack-redirect";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ApiKeysRouteRoute: typeof ApiKeysRouteRouteWithChildren;
  PermissionGroupsRouteRoute: typeof PermissionGroupsRouteRouteWithChildren;
  ProfileRouteRoute: typeof ProfileRouteRouteWithChildren;
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren;
  StringsRouteRoute: typeof StringsRouteRouteWithChildren;
  UsersRouteRoute: typeof UsersRouteRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/users": {
      id: "/users";
      path: "/users";
      fullPath: "/users";
      preLoaderRoute: typeof UsersRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/strings": {
      id: "/strings";
      path: "/strings";
      fullPath: "/strings";
      preLoaderRoute: typeof StringsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/settings": {
      id: "/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof SettingsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/profile": {
      id: "/profile";
      path: "/profile";
      fullPath: "/profile";
      preLoaderRoute: typeof ProfileRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/permission-groups": {
      id: "/permission-groups";
      path: "/permission-groups";
      fullPath: "/permission-groups";
      preLoaderRoute: typeof PermissionGroupsRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/api-keys": {
      id: "/api-keys";
      path: "/api-keys";
      fullPath: "/api-keys";
      preLoaderRoute: typeof ApiKeysRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/users/": {
      id: "/users/";
      path: "/";
      fullPath: "/users/";
      preLoaderRoute: typeof UsersIndexRouteImport;
      parentRoute: typeof UsersRouteRoute;
    };
    "/strings/": {
      id: "/strings/";
      path: "/";
      fullPath: "/strings/";
      preLoaderRoute: typeof StringsIndexRouteImport;
      parentRoute: typeof StringsRouteRoute;
    };
    "/settings/": {
      id: "/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof SettingsIndexRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
    "/profile/": {
      id: "/profile/";
      path: "/";
      fullPath: "/profile/";
      preLoaderRoute: typeof ProfileIndexRouteImport;
      parentRoute: typeof ProfileRouteRoute;
    };
    "/permission-groups/": {
      id: "/permission-groups/";
      path: "/";
      fullPath: "/permission-groups/";
      preLoaderRoute: typeof PermissionGroupsIndexRouteImport;
      parentRoute: typeof PermissionGroupsRouteRoute;
    };
    "/api-keys/": {
      id: "/api-keys/";
      path: "/";
      fullPath: "/api-keys/";
      preLoaderRoute: typeof ApiKeysIndexRouteImport;
      parentRoute: typeof ApiKeysRouteRoute;
    };
    "/settings/integrations/slack-redirect": {
      id: "/settings/integrations/slack-redirect";
      path: "/integrations/slack-redirect";
      fullPath: "/settings/integrations/slack-redirect";
      preLoaderRoute: typeof SettingsIntegrationsSlackRedirectRouteImport;
      parentRoute: typeof SettingsRouteRoute;
    };
  }
}

interface ApiKeysRouteRouteChildren {
  ApiKeysIndexRoute: typeof ApiKeysIndexRoute;
}

const ApiKeysRouteRouteChildren: ApiKeysRouteRouteChildren = {
  ApiKeysIndexRoute: ApiKeysIndexRoute,
};

const ApiKeysRouteRouteWithChildren = ApiKeysRouteRoute._addFileChildren(
  ApiKeysRouteRouteChildren,
);

interface PermissionGroupsRouteRouteChildren {
  PermissionGroupsIndexRoute: typeof PermissionGroupsIndexRoute;
}

const PermissionGroupsRouteRouteChildren: PermissionGroupsRouteRouteChildren = {
  PermissionGroupsIndexRoute: PermissionGroupsIndexRoute,
};

const PermissionGroupsRouteRouteWithChildren =
  PermissionGroupsRouteRoute._addFileChildren(
    PermissionGroupsRouteRouteChildren,
  );

interface ProfileRouteRouteChildren {
  ProfileIndexRoute: typeof ProfileIndexRoute;
}

const ProfileRouteRouteChildren: ProfileRouteRouteChildren = {
  ProfileIndexRoute: ProfileIndexRoute,
};

const ProfileRouteRouteWithChildren = ProfileRouteRoute._addFileChildren(
  ProfileRouteRouteChildren,
);

interface SettingsRouteRouteChildren {
  SettingsIndexRoute: typeof SettingsIndexRoute;
  SettingsIntegrationsSlackRedirectRoute: typeof SettingsIntegrationsSlackRedirectRoute;
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsIntegrationsSlackRedirectRoute:
    SettingsIntegrationsSlackRedirectRoute,
};

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
);

interface StringsRouteRouteChildren {
  StringsIndexRoute: typeof StringsIndexRoute;
}

const StringsRouteRouteChildren: StringsRouteRouteChildren = {
  StringsIndexRoute: StringsIndexRoute,
};

const StringsRouteRouteWithChildren = StringsRouteRoute._addFileChildren(
  StringsRouteRouteChildren,
);

interface UsersRouteRouteChildren {
  UsersIndexRoute: typeof UsersIndexRoute;
}

const UsersRouteRouteChildren: UsersRouteRouteChildren = {
  UsersIndexRoute: UsersIndexRoute,
};

const UsersRouteRouteWithChildren = UsersRouteRoute._addFileChildren(
  UsersRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ApiKeysRouteRoute: ApiKeysRouteRouteWithChildren,
  PermissionGroupsRouteRoute: PermissionGroupsRouteRouteWithChildren,
  ProfileRouteRoute: ProfileRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  StringsRouteRoute: StringsRouteRouteWithChildren,
  UsersRouteRoute: UsersRouteRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
